<mat-dialog-content>
  <app-login-main [inPopup]='true' [activeScreen]="data.activeScreen"></app-login-main>
<mat-dialog-content>